import { render, staticRenderFns } from "./Trailers.vue?vue&type=template&id=71b18726&"
import script from "./Trailers.vue?vue&type=script&lang=js&"
export * from "./Trailers.vue?vue&type=script&lang=js&"
import style0 from "./Trailers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports